module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-menu menu"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-pic-cont"
  }, [_c('div', {
    staticClass: "user-pic fx-align b-r-50"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.logo_url || _vm.logo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-top"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fx fx-x-between fx-y-center"
  }, [_c('p', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.userInfo.username || _vm.userInfo.phone))])])]), _vm._v(" "), _c('nav', [_c('ul', [_c('router-link', {
    class: {
      'active': _vm.active == 'mgIndex'
    },
    attrs: {
      "to": {
        name: 'mgIndex'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-index"
  }), _vm._v("首页")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'mgBusiness'
    },
    attrs: {
      "to": {
        name: 'businessManage'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-index"
  }), _vm._v("商家管理")]), _vm._v(" "), _c('router-link', {
    class: {
      'active': _vm.active == 'mgMessage'
    },
    attrs: {
      "to": {
        name: 'mgMessageList'
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "icon-index"
  }), _vm._v("消息中心")])], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "support"
  }, [_c('p', [_vm._v("技术支持")]), _vm._v(" "), _c('p', [_vm._v("QQ：877200772")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7a97a91e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mg/Menu.vue
// module id = 869
// module chunks = 0